import { color } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import Text from "../../Text";
export const GradientText = styled(Text) `
  background: linear-gradient(
    270deg,
    ${color.brand.secondary.light} 0%,
    ${color.brand.highlight.default} 50%,
    ${color.brand.highlight.light} 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR3JhZGllbnRUZXh0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvTmV3RmxhZy9zdHlsZWQvR3JhZGllbnRUZXh0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxLQUFLLEVBQUUsTUFBTSxnREFBZ0QsQ0FBQztBQUN2RSxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUN2QyxPQUFPLElBQUksTUFBTSxZQUFZLENBQUM7QUFFOUIsTUFBTSxDQUFDLE1BQU0sWUFBWSxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQTs7O01BR2xDLEtBQUssQ0FBQyxLQUFLLENBQUMsU0FBUyxDQUFDLEtBQUs7TUFDM0IsS0FBSyxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUMsT0FBTztNQUM3QixLQUFLLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQyxLQUFLOzs7O0NBSWhDLENBQUMifQ==